import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { usePlatformPermissions } from '../hooks/usePlatformPermissions';
import { ROUTE_VIEW_PERMISSION } from '../config/platform-permissions';

export function PlatformPermissionGuard({
  permission,
  children,
}: {
  permission: string;
  children: ReactNode;
  fallback?: ReactNode;
}) {
  const { loading, can } = usePlatformPermissions();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[40vh] text-sm text-gray-400">
        …
      </div>
    );
  }

  if (!can(permission)) {
    const alternate = Object.entries(ROUTE_VIEW_PERMISSION).find(([, key]) => can(key));
    if (alternate) {
      return <Navigate to={alternate[0]} replace />;
    }
    return (
      <div className="flex flex-col items-center justify-center min-h-screen gap-3 p-6 text-center">
        <i className="ri-lock-2-line text-3xl text-gray-400" />
        <p className="text-sm font-semibold text-gray-700">ليس لديك صلاحية للوصول</p>
        <p className="text-xs text-gray-400">تواصل مع مسؤول النظام لتفعيل الصلاحيات المطلوبة</p>
      </div>
    );
  }

  return <>{children}</>;
}
